const doc = [({"ko":({"adminConstantChargeType":({"perPerson":"사람마다", "perRoom":"객실당"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;